module.exports = __webpack_public_path__ + "img/1.0dcabf89.png";